import axios from 'axios'
import jwtDecode from 'jwt-decode'
import moment from 'moment'
import socket from '@/config/socket'
import { storage } from '@/config/functions'

const state = {
  authenticated: false,
  remember: false,
  tokenPayload: {
    sub: null,
    sessionId: null,
    iat: null,
    exp: null
  },
  currentUser: {
    _id: null,
    type: null,
    companyId: null,
    avatar: null,
    name: null,
    email: null,
    role: null,
    department: null,
    canSeeFunctionalities: true,
    privilege: {}
  }
}

const getters = {
  getCurrentUser: state => state.currentUser,
  getTokenPayload: state => state.tokenPayload,
  getPermissions: state => state.currentUser.privilege ? state.currentUser.privilege.permissions : null,
  getAvatar: state => state.currentUser.avatar,
  isAuthenticated: state => state.authenticated,
  isRemembered: state => state.remember,
  canSeeFunctionalities: state => state.currentUser.canSeeFunctionalities
}

const mutations = {
  setTokenPayload (state, payload) {
    state.tokenPayload = payload
  },
  setCurrentUser (state, payload) {
    state.authenticated = !!payload
    state.currentUser = payload !== null ? payload : {}
  },
  setAuthorization (state, { token, remember }) {
    storage(remember).token = token

    state.remember = remember

    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
  },
  removeAuthorization (state, payload) {
    delete axios.defaults.headers.common['Authorization']
    delete storage(state.remember).token
    delete storage(state.remember).notifications
    delete storage(state.remember).company
    delete storage(state.remember).darkMode

    socket.emit('leaveAll')
  },
  setCanSeeFunctionalities (state, payload) {
    state.currentUser.canSeeFunctionalities = payload
  },
  setAvatar (state, payload) {
    state.currentUser.avatar = payload
  }
}

const actions = {
  attemptLogin ({ commit, dispatch }, { user, token, remember }) {

    const payload = jwtDecode(token)

    if (moment().unix() < payload.exp) {
      commit('setTokenPayload', payload)
      commit('setAuthorization', { token, remember })
      commit('setCurrentUser', user)
    } else {
      dispatch('removeCurrentUser')
    }
  },
  removeCurrentUser ({ commit, dispatch }) {
    commit('removeAuthorization')
    commit('setCurrentUser', null)
    commit('App/setDarkMode', { darkMode: false }, { root: true })
    commit('App/setCompany', { id: null }, { root: true })
    dispatch('App/unsubscribePush', { skipAPI: true }, { root: true })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/Auth.js